module.exports = __webpack_public_path__ + "static/media/7.613d187d.jpg";